/**
 * PDP Éditeur 2.0 bridge:
 * - 3-tab app_handler UX helpers
 * - launch /pages/editeur-sherpa?mode=order
 * - restore PDF into UploadLift on return
 */
(function () {
  'use strict';

  if (window.__pdpEditorV2Ready) return;
  window.__pdpEditorV2Ready = true;

  var CTX_KEY = 'sherpa_order_ctx';
  var PENDING_KEY = 'sherpa_order_pending';
  var EXPAND_KEY = 'sherpa_order_expand';
  var IDB_NAME = 'sherpa-order-db';
  var IDB_STORE = 'files';
  var IDB_VERSION = 1;

  function parseJsonScript(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (err) {
      console.warn('[pdp-editor-v2] JSON parse failed', selector, err);
      return null;
    }
  }

  function selectedVariantId() {
    var input =
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"]');
    var value = input && input.value ? String(input.value) : '';
    return value ? Number(value) : null;
  }

  function setStatus(root, message, tone) {
    var status = root.querySelector('[data-sherpa-order-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.remove('is-error', 'is-success');
    if (tone) status.classList.add(tone);
  }

  function shouldPreserveUpload(root) {
    if (!root) return false;
    if (root.dataset.sherpaFileReady === 'true') return true;
    if (root.dataset.appMode === 'editor2') return true;
    if (root.querySelector('input[data-app-mode-value="editor2"]:checked')) return true;
    return false;
  }

  function clearUploadAndPrintApp(root) {
    if (shouldPreserveUpload(root)) return;
    document.querySelectorAll('.filepond--file-action-button').forEach(function (btn) {
      if (!btn.hasAttribute('disabled')) btn.click();
    });
    document.querySelectorAll('#pa-buttons button').forEach(function (btn) {
      if (btn.getAttribute('@click.prevent.stop') === 'clearDesign') btn.click();
    });
  }

  function setAppMode(root, mode, options) {
    var opts = options || {};
    var input = root.querySelector('input[data-app-mode-value="' + mode + '"]');
    root.dataset.appMode = mode;
    if (!input) return;
    input.checked = true;
    if (opts.silent) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function clearExpandFlag() {
    try {
      sessionStorage.removeItem(EXPAND_KEY);
    } catch (err) {
      /* ignore */
    }
  }

  function revealOrderSection() {
    // Expand in-page only. Do not persist a sticky flag — that hid "Commander en ligne"
    // on every subsequent visit.
    clearExpandFlag();
    if (typeof window.__sherpaRevealPdpOrderSection === 'function') {
      window.__sherpaRevealPdpOrderSection();
      return;
    }
    var opener = document.querySelector('.js--show--hidden-elements');
    if (opener) opener.classList.add('visually-hidden');
    [
      '.shopacado--table__container',
      '#countdown-timer',
      '.upload-lift',
      '.product-form',
      'pickup-availability',
      '.tooltip',
      '[is-app-handler]',
    ].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      el.style.position = 'relative';
      el.style.left = 'unset';
    });
    document.querySelectorAll('.js-hide-after-click').forEach(function (el) {
      el.classList.add('visuallyhidden');
    });
  }

  function markFileReady(root, filename) {
    root.dataset.sherpaFileReady = 'true';
    var launchBtn = root.querySelector('[data-sherpa-order-launch]');
    if (launchBtn) {
      launchBtn.textContent = 'Rouvrir l’éditeur 2.0';
    }
    setStatus(
      root,
      (filename ? 'Planche prête : ' + filename + '. ' : 'Planche prête. ') +
        'Finalisez vos options puis ajoutez au panier.',
      'is-success'
    );
  }

  function openIdb() {
    return new Promise(function (resolve, reject) {
      var req = indexedDB.open(IDB_NAME, IDB_VERSION);
      req.onupgradeneeded = function () {
        var db = req.result;
        if (!db.objectStoreNames.contains(IDB_STORE)) {
          db.createObjectStore(IDB_STORE);
        }
      };
      req.onsuccess = function () {
        resolve(req.result);
      };
      req.onerror = function () {
        reject(req.error || new Error('IndexedDB unavailable'));
      };
    });
  }

  function idbGet(key) {
    return openIdb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(IDB_STORE, 'readonly');
        var store = tx.objectStore(IDB_STORE);
        var req = store.get(key);
        req.onsuccess = function () {
          resolve(req.result || null);
        };
        req.onerror = function () {
          reject(req.error);
        };
      });
    });
  }

  function idbDelete(key) {
    return openIdb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(IDB_STORE, 'readwrite');
        var store = tx.objectStore(IDB_STORE);
        var req = store.delete(key);
        req.onsuccess = function () {
          resolve();
        };
        req.onerror = function () {
          reject(req.error);
        };
      });
    });
  }

  function apiFromCandidate(candidate) {
    if (!candidate || typeof candidate !== 'object') return null;
    if (typeof candidate.uploadFile === 'function') return candidate;
    var nestedKeys = ['__field', 'field', 'uploadLift'];
    for (var i = 0; i < nestedKeys.length; i += 1) {
      var nested = candidate[nestedKeys[i]];
      if (nested && typeof nested.uploadFile === 'function') return nested;
    }
    return null;
  }

  function findUploadLiftField() {
    var win = window;
    var globalField =
      apiFromCandidate(win.__lnUploadField) ||
      apiFromCandidate(win.field) ||
      apiFromCandidate(win.uploadLiftField) ||
      apiFromCandidate(win.UploadLift) ||
      apiFromCandidate(win.UploadLift && win.UploadLift.field) ||
      apiFromCandidate(win.UploadLift && win.UploadLift.fields && win.UploadLift.fields[0]) ||
      apiFromCandidate(win.UploadLift && win.UploadLift.instances && win.UploadLift.instances[0]);
    if (globalField) return globalField;

    var containers = document.querySelectorAll(
      '.upload-fast-order, .upload-lift, [data-upload-lift], [data-uploadlift]'
    );
    for (var c = 0; c < containers.length; c += 1) {
      var el = containers[c];
      var field =
        apiFromCandidate(el) ||
        apiFromCandidate(el.__field) ||
        apiFromCandidate(el.field) ||
        apiFromCandidate(el.uploadLift) ||
        apiFromCandidate(el.firstElementChild) ||
        apiFromCandidate(el.firstElementChild && el.firstElementChild.__field);
      if (field) return field;
      var descendants = el.querySelectorAll('*');
      for (var d = 0; d < descendants.length; d += 1) {
        var found = apiFromCandidate(descendants[d]) || apiFromCandidate(descendants[d].__field);
        if (found) return found;
      }
    }
    return null;
  }

  function waitForUploadLiftField(timeoutMs) {
    var started = Date.now();
    var timeout = typeof timeoutMs === 'number' ? timeoutMs : 15000;
    return new Promise(function (resolve) {
      function tick() {
        var field = findUploadLiftField();
        if (field) {
          resolve(field);
          return;
        }
        if (Date.now() - started >= timeout) {
          resolve(null);
          return;
        }
        setTimeout(tick, 120);
      }
      tick();
    });
  }


  // Fast Order PDPs have two Upload-Lift instances:
  // - hidden .upload-fast-order bridge
  // - customer-facing .fo-pdp-native-upload
  //
  // Upload-Lift exposes the field through the canonical `upload:ready` event.
  // Keep only the native field and re-check it against the current DOM because
  // selecting a variant can re-render ProductInfo.
  var nativeUploadLiftField = null;

  function uploadLiftFieldBelongsToNative(field) {
    if (!field || !field.element || field.element.nodeType !== 1) return false;

    var container = document.querySelector('.fo-pdp-native-upload');
    if (!container) return false;

    return (
      field.element === container ||
      container.contains(field.element) ||
      (typeof field.element.contains === 'function' &&
        field.element.contains(container))
    );
  }

  function rememberNativeUploadLiftField(candidate) {
    var field = apiFromCandidate(candidate);
    if (!field) return null;

    // Preserve the historical global used by legacy PDPs/debugging.
    window.__lnUploadField = field;

    if (uploadLiftFieldBelongsToNative(field)) {
      nativeUploadLiftField = field;
    }

    return field;
  }

  function findNativeUploadLiftField() {
    if (
      nativeUploadLiftField &&
      uploadLiftFieldBelongsToNative(nativeUploadLiftField)
    ) {
      return nativeUploadLiftField;
    }

    // The ready event may have fired before this restore path started.
    var globalField = apiFromCandidate(window.__lnUploadField);
    if (globalField && uploadLiftFieldBelongsToNative(globalField)) {
      nativeUploadLiftField = globalField;
      return globalField;
    }

    return null;
  }

  function waitForNativeUploadLiftField(timeoutMs) {
    var started = Date.now();
    var timeout = typeof timeoutMs === 'number' ? timeoutMs : 15000;

    return new Promise(function (resolve) {
      function tick() {
        var field = findNativeUploadLiftField();
        if (field) {
          resolve(field);
          return;
        }

        if (Date.now() - started >= timeout) {
          resolve(null);
          return;
        }

        setTimeout(tick, 120);
      }

      tick();
    });
  }

  function selectVariantOnPdp(variantId) {
    if (!variantId) return;
    var id = String(variantId);
    var numericId = Number(id);
    var selectors = document.querySelectorAll('variant-selects');

    selectors.forEach(function (selector) {
      var script = selector.querySelector('script[type="application/json"]');
      var variants = [];
      try {
        variants = script ? JSON.parse(script.textContent || '[]') : [];
      } catch (err) {
        variants = [];
      }
      var variant = variants.find(function (v) {
        return Number(v.id) === numericId;
      });
      if (!variant || !Array.isArray(variant.options)) return;

      var fieldsets = Array.from(selector.querySelectorAll('fieldset'));
      variant.options.forEach(function (optionValue, index) {
        var fieldset = fieldsets[index];
        if (!fieldset) return;
        var select = fieldset.querySelector('select');
        if (select) {
          select.value = optionValue;
          return;
        }
        var input = fieldset.querySelector(
          'input[value="' + String(optionValue).replace(/"/g, '\\"') + '"]'
        );
        if (input) input.checked = true;
      });

      selector.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var formIdInput =
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"]');
    if (formIdInput) {
      formIdInput.value = id;
      formIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    try {
      document.dispatchEvent(
        new CustomEvent('product:variant-change', {
          detail: { variant: { id: numericId } },
        })
      );
    } catch (err) {
      /* ignore */
    }
  }

  function formatKeyFromOption(text) {
    var t = String(text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
    if (!t) return null;
    if (/\bmetre\b|\bmeter\b/.test(t) || /57\s*x\s*100/.test(t)) return '570x1000';
    if (/\ba7\b/.test(t) || /6\s*x\s*10/.test(t)) return '60x100';
    if (/\ba6\b/.test(t) || /10\s*x\s*14/.test(t)) return '100x140';
    if (/\ba5\b/.test(t) || /14\s*x\s*21/.test(t)) return '140x210';
    if (/\ba4\+/.test(t) || /a4\s*\+/.test(t) || /21\s*x\s*30/.test(t)) return '210x300';
    if (/\ba4\b/.test(t) || /21\s*x\s*28/.test(t)) return '210x280';
    if (/\ba3\+/.test(t) || /a3\s*\+/.test(t) || /30\s*x\s*43/.test(t)) return '300x430';
    if (/\ba3\b/.test(t) || /28\s*x\s*42/.test(t)) return '280x420';
    if (/\ba2\b/.test(t) || /42\s*x\s*58/.test(t)) return '420x580';
    return null;
  }

  function formatKeyForVariant(variant, optionNames) {
    if (!variant) return null;
    var names = Array.isArray(optionNames) ? optionNames : [];
    var formatIdx = names.findIndex(function (name) {
      return /format/i.test(String(name || ''));
    });
    if (formatIdx >= 0) return formatKeyFromOption(variant.options && variant.options[formatIdx]);
    return formatKeyFromOption(variant.title);
  }

  function forfaitFormatFromProductTitle(title) {
    var t = String(title || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
    if (!/forfait\s+impression/.test(t)) return null;
    return formatKeyFromOption(title);
  }

  function buildLaunchContext(root) {
    var options = parseJsonScript(root, '[data-sherpa-order-options]') || [];
    var variants = parseJsonScript(root, '[data-sherpa-order-variants]') || [];
    var variantId = selectedVariantId() || (variants[0] && variants[0].id) || null;
    var selected = variants.find(function (v) {
      return Number(v.id) === Number(variantId);
    });
    var productTitle = root.dataset.productTitle || '';
    var format = formatKeyForVariant(selected, options) || forfaitFormatFromProductTitle(productTitle);
    return {
      productHandle: root.dataset.productHandle || '',
      productId: root.dataset.productId || '',
      productTitle: productTitle,
      variantId: variantId,
      format: format,
      optionNames: options,
      variants: variants,
      returnPath: window.location.pathname + window.location.search + window.location.hash,
    };
  }

  function waitForSherpaEditorPdp(timeoutMs) {
    var started = Date.now();
    var timeout = typeof timeoutMs === 'number' ? timeoutMs : 8000;
    return new Promise(function (resolve) {
      function tick() {
        if (window.SherpaEditorPdp && typeof window.SherpaEditorPdp.openOrderMode === 'function') {
          resolve(window.SherpaEditorPdp);
          return;
        }
        if (Date.now() - started >= timeout) {
          resolve(null);
          return;
        }
        setTimeout(tick, 50);
      }
      tick();
    });
  }

  async function launchEditor(root) {
    var ctx = buildLaunchContext(root);
    if (!ctx.productHandle || !ctx.variantId) {
      setStatus(root, 'Variante introuvable pour lancer l’éditeur.', 'is-error');
      return;
    }

    try {
      sessionStorage.setItem(CTX_KEY, JSON.stringify(ctx));
      // Overlay stays on the PDP — do not sticky-expand the order form for later visits.
    } catch (err) {
      console.warn('[pdp-editor-v2] sessionStorage failed', err);
    }

    if (root.dataset.customerLoggedIn !== 'true') {
      var returnToPdp = new URL(window.location.href);
      returnToPdp.searchParams.set('sherpa_open', '1');
      var loginUrl = new URL(root.dataset.loginUrl || '/account/login', window.location.origin);
      loginUrl.searchParams.set('return_url', returnToPdp.pathname + returnToPdp.search + returnToPdp.hash);
      window.location.href = loginUrl.toString();
      return;
    }

    var api = await waitForSherpaEditorPdp();
    if (!api) {
      setStatus(root, 'Éditeur indisponible. Rechargez la page puis réessayez.', 'is-error');
      return;
    }
    api.openOrderMode(ctx);
  }

  function onSherpaClose() {
    if (window.SherpaEditorPdp) window.SherpaEditorPdp.close();
  }

  function onSherpaOrder(event) {
    var root = document.querySelector('[is-app-handler]');
    if (!root) return;
    var pending = event && event.detail && event.detail.pending;
    if (pending) {
      try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
        sessionStorage.setItem(EXPAND_KEY, '1');
      } catch (err) {
        console.warn('[pdp-editor-v2] could not persist pending order', err);
      }
    }
    revealOrderSection();
    setAppMode(root, 'editor2', { silent: true });
    restorePendingOrder(root);
  }

  function stripPendingQuery() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('sherpa_order')) return;
      url.searchParams.delete('sherpa_order');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (err) {
      /* ignore */
    }
  }

  async function restorePendingOrder(root) {
    var raw = null;
    try {
      raw = sessionStorage.getItem(PENDING_KEY);
    } catch (err) {
      raw = null;
    }
    if (!raw) return;

    var pending = null;
    try {
      pending = JSON.parse(raw);
    } catch (err) {
      pending = null;
    }
    if (!pending || !pending.productHandle) return;
    if (pending.productHandle !== root.dataset.productHandle) return;

    // Forfait PDFs belong to the multi-file modal, not the hidden native uploader.
    if (document.querySelector('.upload-forfait-fast-order')) {
      if (root.__forfaitRestoreRunning) return;
      root.__forfaitRestoreRunning = true;
      try {
        setStatus(root, 'Ajout du fichier généré…', null);
        var forfaitRecord = await idbGet(pending.idbKey || 'pending');
        if (!forfaitRecord || !forfaitRecord.blob) {
          throw new Error('Fichier introuvable après retour de l’éditeur.');
        }
        if (!window.ForfaitFastOrder || typeof window.ForfaitFastOrder.importFiles !== 'function') {
          throw new Error('Forfait Fast Order indisponible. Rechargez la page puis réessayez.');
        }
        var forfaitFile = new File([forfaitRecord.blob], pending.filename || 'planche-sherpa.pdf', {
          type: forfaitRecord.type || 'application/pdf'
        });
        await window.ForfaitFastOrder.importFiles([forfaitFile]);
        sessionStorage.removeItem(PENDING_KEY);
        await idbDelete(pending.idbKey || 'pending').catch(function () {});
        stripPendingQuery();
        setAppMode(root, 'editor2', { silent: true });
        setStatus(root, 'Planche ajoutée à Forfait Fast Order.', 'is-success');
      } catch (err) {
        console.error('[pdp-editor-v2] forfait restore failed', err);
        setStatus(root, (err && err.message) || 'Impossible d’ajouter le fichier.', 'is-error');
      } finally {
        root.__forfaitRestoreRunning = false;
      }
      return;
    }

    // Re-open the collapsed "Commander en ligne" block before attaching the file.
    revealOrderSection();

    var isFastOrderPdp = !!document.querySelector('.fo-pdp-native-upload');

    // Legacy PDPs keep the historical silent import -> editor2 sequence.
    // Dedicated Fast Order PDPs must really activate "Importer un fichier"
    // so the customer-facing native Upload-Lift field can mount and receive the PDF.
    if (isFastOrderPdp) {
      setAppMode(root, 'import');
    } else {
      setAppMode(root, 'import', { silent: true });
    }

    setStatus(root, 'Ajout du fichier généré…', null);
    selectVariantOnPdp(pending.variantId);

    try {
      var record = await idbGet(pending.idbKey || 'pending');
      if (!record || !record.blob) {
        throw new Error('Fichier introuvable après retour de l’éditeur.');
      }

      var field = isFastOrderPdp
        ? await waitForNativeUploadLiftField(20000)
        : await waitForUploadLiftField(20000);

      if (!field) {
        throw new Error('Upload-Lift indisponible. Réessayez ou importez le fichier manuellement.');
      }

      if (isFastOrderPdp) {
        // Variant selection can replace ProductInfo. Re-resolve the live App Handler
        // and activate Import again so the native tab/body mode matches the field
        // that is about to receive the generated PDF.
        root = document.querySelector('[is-app-handler]') || root;
        setAppMode(root, 'import');
      }

      var filename = pending.filename || 'planche-sherpa.pdf';
      var file = new File([record.blob], filename, {
        type: record.type || 'application/pdf',
      });
      await field.uploadFile(file);

      markFileReady(root, filename);

      // After Upload-Lift has received the generated PDF, restore Editor 2.0.
      // Legacy PDPs keep the historical silent switch.
      // Dedicated Fast Order PDPs dispatch the change event as well so the
      // template-specific body mode/UI is restored to Editor 2.0 while the
      // uploaded file remains preserved in the native Upload-Lift field.
      if (isFastOrderPdp) {
        setAppMode(root, 'editor2');
      } else {
        setAppMode(root, 'editor2', { silent: true });
      }

      root.scrollIntoView({ block: 'center', behavior: 'smooth' });

      try {
        sessionStorage.removeItem(PENDING_KEY);
      } catch (err) {
        /* ignore */
      }
      await idbDelete(pending.idbKey || 'pending').catch(function () {});
      stripPendingQuery();
    } catch (err) {
      console.error('[pdp-editor-v2] restore failed', err);
      setStatus(root, (err && err.message) || 'Impossible d’ajouter le fichier.', 'is-error');
      if (isFastOrderPdp) {
        setAppMode(root, 'editor2');
      } else {
        setAppMode(root, 'editor2', { silent: true });
      }
    }
  }

  function hasPrintAppCreateMapping() {
    var container = document.querySelector('#pa-buttons');
    if (!container) return false;
    return !!container.querySelector(
      'button, a, [role="button"], input[type="button"], input[type="submit"]'
    );
  }

  // Catalogue Print.App V1+V2 only. Forfaits / étiquettes / écussons stay unchanged.
  var HIDE_PRINTAPP_V1_HANDLES = {
    'impression-dtf-pro-max-metre': true,
    'impression-dtf-pro-max-en-planche-a2-a3': true,
    'impression-dtf-softshell-blockmax-au-metre': true,
    'impression-dtf-softshell-block': true,
    'impression-dtf-en-planche-discount-test': true,
    'impression-transfert-dtf-au-metre': true,
    'impression-dtf-en-planche': true,
    'impression-dtf-en-planche-offre-decathlon': true,
    'transfert-de-sublimation-textile-au-metre': true,
    'transfert-de-sublimation-en-planche': true,
    'transfert-de-sublimation-textile-pret-a-presser-decathlon': true,
    'transfert-de-sublimation-objet-au-metre': true,
    'transfert-de-sublimation-objet-en-planche': true,
    'transfert-serigraphique-monochrome-couleur': true,
    'transfert-serigraphique-monochrome-fluo': true,
    'transfert-serigraphique-monochrome-en-planche': true,
    'transfert-serigraphique-metallique-or-argent': true,
    'impression-transfert-uv-dtf-objet': true,
    'stickers-uv-dtf-prets-a-poser-decathlon': true
  };

  function shouldHidePrintAppV1(root) {
    if (document.getElementById('hide-printapp-v1')) return true;
    var handle = (root && root.dataset && root.dataset.productHandle) || '';
    return !!HIDE_PRINTAPP_V1_HANDLES[handle];
  }

  function setCreateTabVisible(root, visible) {
    if (visible && shouldHidePrintAppV1(root)) visible = false;
    var tab = root.querySelector('[data-app-handler-create-tab]');
    if (!tab) return;

    if (visible) {
      tab.hidden = false;
      root.classList.remove('app_handler--no-create');
      root.dataset.createMapped = 'true';
      return;
    }

    tab.hidden = true;
    root.classList.add('app_handler--no-create');
    root.dataset.createMapped = 'false';

    var createInput = tab.querySelector('input[data-app-mode-value="create"]');
    if (createInput && createInput.checked) {
      setAppMode(root, 'import');
    }
  }

  function watchCreateTabMapping(root) {
    if (root.__pdpCreateTabWatch) return;
    root.__pdpCreateTabWatch = true;

    // Hidden by default in Liquid; show only once Print.App maps the product.
    setCreateTabVisible(root, false);

    var settled = false;
    function apply() {
      var mapped = hasPrintAppCreateMapping();
      if (mapped) {
        settled = true;
        setCreateTabVisible(root, true);
        return true;
      }
      return false;
    }

    if (apply()) return;

    var observer = new MutationObserver(function () {
      if (apply() && observer) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (apply() || attempts >= 20) {
        clearInterval(timer);
        if (!settled && !hasPrintAppCreateMapping()) {
          setCreateTabVisible(root, false);
        }
        if (settled || attempts >= 20) observer.disconnect();
      }
    }, 250);

    window.addEventListener('load', function () {
      apply();
    });
  }

  function bindRoot(root) {
    if (root.__pdpEditorV2Bound) return;
    root.__pdpEditorV2Bound = true;

    watchCreateTabMapping(root);

    root.querySelectorAll('[is-app-handler-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var mode = input.getAttribute('data-app-mode-value') || 'import';
        root.dataset.appMode = mode;
        // Never wipe a Sherpa-attached planche when switching tabs.
        if (mode === 'editor2' || root.dataset.sherpaFileReady === 'true') return;
        clearUploadAndPrintApp(root);
      });
    });

    var launchBtn = root.querySelector('[data-sherpa-order-launch]');
    if (launchBtn) {
      launchBtn.addEventListener('click', function (event) {
        event.preventDefault();
        launchEditor(root);
      });
    }

    try {
      var shouldExpand =
        sessionStorage.getItem(PENDING_KEY) ||
        new URLSearchParams(window.location.search).get('sherpa_order') ||
        sessionStorage.getItem(EXPAND_KEY) === '1';
      if (shouldExpand) {
        clearExpandFlag();
        revealOrderSection();
      }
    } catch (err) {
      /* ignore */
    }

    restorePendingOrder(root);
  }

  function boot() {
    // Ensure PDP is scrollable if a previous editor session left a lock.
    document.documentElement.classList.remove('sherpa-editor-open', 'sherpa-embed');
    document.documentElement.style.overflow = '';
    if (document.body) {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
    }
    var embeddedApp = document.getElementById('sherpa-editor-app');
    if (embeddedApp && embeddedApp.classList.contains('sherpa-editor--pdp-embed')) {
      embeddedApp.classList.remove('is-open');
    }

    document.querySelectorAll('[is-app-handler]').forEach(bindRoot);
    document.addEventListener('sherpa:close', onSherpaClose);
    document.addEventListener('sherpa:order', onSherpaOrder);

    function onUploadLiftReady(event) {
      if (event && event.detail) {
        rememberNativeUploadLiftField(event.detail);
      }
    }

    window.addEventListener('upload:ready', onUploadLiftReady);

    // If the canonical ready event fired before boot, reuse the exposed field.
    rememberNativeUploadLiftField(window.__lnUploadField);

    // Resume overlay after login redirect.
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('sherpa_open') === '1') {
        params.delete('sherpa_open');
        var clean =
          window.location.pathname +
          (params.toString() ? '?' + params.toString() : '') +
          window.location.hash;
        window.history.replaceState({}, '', clean);
        var root = document.querySelector('[is-app-handler]');
        if (root && root.dataset.customerLoggedIn === 'true') {
          setAppMode(root, 'editor2', { silent: true });
          launchEditor(root);
        }
      }
    } catch (err) {
      /* ignore */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();